import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

const Statistics = ({ stats }) => {
    return (
        <Grid
            container
            spacing={2}
            justifyContent="space-evenly"
        >
            {stats.map((stat, index) => (
                <Grid item xs={12} sm={12} md={4} key={`stat${index}`}>
                    <Card sx={{ height: '100%' }}>
                        <CardContent align="left">
                            <Typography variant="h4">
                                {stat.value}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {stat.label}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}

export default Statistics;